import PropTypes from 'prop-types';
import React from 'react';
import { withTranslation } from 'react-i18next';
import { Tab, Tabs } from '@blueprintjs/core';

import ChronoCooc from './ChronoCooc';
import ChronoOccs from './ChronoOccs';
import ChronoOccsByRealization from './ChronoOccsByRealization';
import ChronoOccsBySubCorpus from './ChronoOccsBySubCorpus';

class Chronogram extends React.PureComponent {

  state = {
    //selectedTabId: Object.keys(this.props.stats.byCorpus)[0],  // select first corpus by default
    selectedTabId:"occs"
  }

  // subCorpora=Object.keys(this.props.stats.byCorpus).sort();


  handleTabChange = (navbarTabId) => {
    this.setState({ selectedTabId: navbarTabId });
    //  this trick is to cope with the react-apex-chart show problem
    window.dispatchEvent(new Event('resize'));
  }

  render() {
    const { data, warningIncompleteExtraction, collocQuery, sessionId, stats, t } = this.props;

    const chronoOccs = <ChronoOccs data={data} warningIncompleteExtraction={warningIncompleteExtraction} />;
    const chronoOccsByRealization = <ChronoOccsByRealization  data={data} stats={stats} warningIncompleteExtraction={warningIncompleteExtraction} />;
    const chronoOccsBySubCorpus = <ChronoOccsBySubCorpus data={data} warningIncompleteExtraction={warningIncompleteExtraction} />;
    const chronoCooc = <ChronoCooc data={data} collocQuery={collocQuery} sessionId={sessionId} warningIncompleteExtraction={warningIncompleteExtraction} />;
    

    const displayChronoOccsByRealization=Object.keys(data.occsByRealization).length > 1;
    const displayCooc = data.cooc.freqByColloc ? Object.keys(data.cooc.freqByColloc).length * Object.keys(data.sortedCollocs).length > 0 : false;
    const displayChronoOccsBySubCorpus=Object.keys(data.occsByCorpus).length > 1;

    return (
      <>
        
        <Tabs onChange={this.handleTabChange} selectedTabId={this.state.selectedTabId}>
          <Tab key={'occs'} id={'occs'} title={t('occurrences')} panel={chronoOccs} />
          { displayChronoOccsByRealization &&
            <Tab key={'occsByRealization'} id={'occsByRealization'} title={t('occsByRealization')} panel={chronoOccsByRealization} />
          }
          { displayChronoOccsBySubCorpus &&
            <Tab key={'occsBySubCorpus'} id={'occsBySubCorpus'} title={t('occsBySubCorpus')} panel={chronoOccsBySubCorpus} />
          }
          { displayCooc &&
            <Tab key={'cooc'} id={'cooc'} title={t('cooc')} panel={chronoCooc} />
          }
        </Tabs>
      </>
    );
  }
}

Chronogram.propTypes = {
  data: PropTypes.object, // special data for chronograms
  stats: PropTypes.object, // global stats data used to sort realizations by global frequency
  sessionId: PropTypes.string,
  collocQuery: PropTypes.object,
  warningIncompleteExtraction: PropTypes.bool,
  performSearch: PropTypes.func,  
  csvDelimiter: PropTypes.string, 
};

export default withTranslation()(Chronogram);
